import React from 'react';
import styled from 'styled-components';
import { HeaderCell, HeaderRow, Row, SectionConditional, Table, TableBody, TableHead, Text } from 'components';
import { theme, toRem } from 'design';

interface IUploadData {
  modifiedName: SampleTable;
  name: SampleTable;
  employeeId: SampleTable;
}

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;

  th:not(:first-child) {
    border-left: ${toRem(1)} solid ${theme.color.neutral[200]};
  }

  tbody tr:hover {
    background-color: ${theme.color.white};
  }
`;

const UploadFormatList = styled.ul`
  padding: ${toRem(20)};
`;

const UploadFormatListItem = styled.li`
  padding: ${toRem(8)} 0;
`;

const SampleDataCell = styled.td`
  padding: ${toRem(4)} ${toRem(16)};

  &:not(:first-child) {
    border-left: 1px solid ${theme.color.neutral[200]};
  }
`;

type SampleTable = {
  headers: string[];
  data: Array<{
    amount: number;
    employeeId?: number;
    name?: string;
    firstName?: string;
    lastName?: string;
  }>;
};

const SAMPLE_UPLOAD_DATA: IUploadData = {
  modifiedName: {
    headers: ['firstName', 'lastName', 'amount'],
    data: [
      {
        firstName: 'Rosemary',
        lastName: 'Fletcher',
        amount: 55.32,
      },
      {
        firstName: 'Jane',
        lastName: 'Smith-Jones',
        amount: 85.9,
      },
    ],
  },
  name: {
    headers: ['Name', 'amount'],
    data: [
      {
        name: 'Rosemary Fletcher',
        amount: 55.32,
      },
      {
        name: 'Jane Smith-Jones',
        amount: 85.9,
      },
    ],
  },
  employeeId: {
    headers: ['employeeID', 'amount'],
    data: [
      {
        employeeId: 9848940123,
        amount: 55.32,
      },
      {
        employeeId: 1651898720,
        amount: 85.9,
      },
    ],
  },
};

const UploadPaymentRequirements: React.FC = () => (
  <Layout>
    {Object.keys(SAMPLE_UPLOAD_DATA).map((upload) => (
      <React.Fragment key={`${upload}-table`}>
        <Table className="sample-data-table">
          <TableHead>
            <HeaderRow>
              {SAMPLE_UPLOAD_DATA[upload as keyof typeof SAMPLE_UPLOAD_DATA].headers.map((header, idx: number) => (
                <HeaderCell key={`${upload}-header-${idx}`}>{header}</HeaderCell>
              ))}
            </HeaderRow>
          </TableHead>
          <TableBody>
            {SAMPLE_UPLOAD_DATA[upload as keyof typeof SAMPLE_UPLOAD_DATA].data.map((col: any, idx: number) => (
              <Row key={`${upload}-data-${idx}`}>
                {col.firstName && <SampleDataCell>{col.firstName}</SampleDataCell>}
                {col.lastName && <SampleDataCell>{col.lastName}</SampleDataCell>}
                {col.name && <SampleDataCell>{col.name}</SampleDataCell>}
                {col.employeeId && <SampleDataCell>{col.employeeId}</SampleDataCell>}
                <SampleDataCell>{col.amount}</SampleDataCell>
              </Row>
            ))}
          </TableBody>
        </Table>

        {upload !== 'employeeId' && <SectionConditional condition="or" />}
      </React.Fragment>
    ))}

    <UploadFormatList>
      <UploadFormatListItem>
        <Text size="small">All other columns will be ignored.</Text>
      </UploadFormatListItem>
      <UploadFormatListItem>
        <Text size="small">The amount column must use dollars and cents with dollar sign optional such as $14.35 or 14.35.</Text>
      </UploadFormatListItem>
    </UploadFormatList>
  </Layout>
);

export default UploadPaymentRequirements;
